import { ChainAddressType as I } from "../../constants/chain.js";
import S from "../generic/useChainSwitcher.js";
import W from "../web3/useWeb3.js";
import C from "../../util/misc/date.js";
import { useCallback as m } from "react";
import { useTranslation as T } from "react-i18next";
import { SiweMessage as v } from "siwe";
const H = () => {
  const { t: l } = T(), { getChainIdByType: u, getChainType: p, getWalletProvider: d } = S(), { signRequest: a, getWalletAccount: w } = W(), i = m((t) => {
    const { message: s, network: n, provider: e, timestamp: r } = t, o = btoa(
      JSON.stringify({
        network: n,
        wallet: e,
        timestamp: r
      })
    );
    return `${s} @${o}`;
  }, []), y = m(
    async (t) => {
      const { wallet: s, timestamp: n } = t, { address: e } = await w(), r = u(I.RONIN), o = C({
        timestamp: n * 1e3,
        formatMethod: "yyyy-MM-dd'T'HH:mm:ssXXX"
      }), c = i(t), g = {
        address: (e == null ? void 0 : e.toString()) || "0x0",
        chainId: r,
        domain: window.location.host,
        issuedAt: o,
        statement: c,
        uri: window.location.origin,
        version: "1"
      }, h = new v(g).toMessage(), M = await a(h, s);
      return { message: h, signature: M };
    },
    [u, w, i, a]
  ), f = m(
    async (t) => {
      const { wallet: s } = t, n = i(t), e = await a(n, s);
      return {
        message: n,
        signature: e
      };
    },
    [i, a]
  );
  return {
    getBindWalletInput: m(
      async (t) => {
        const s = p(t), n = d(t), e = Math.floor(Date.now() / 1e3), o = window.location.protocol === "http:" ? f : y, { message: c, signature: g } = await o({
          message: l("login.signature_statement"),
          network: s,
          provider: n,
          timestamp: e,
          wallet: t
        });
        return {
          message: c,
          messageTimestamp: e,
          network: s,
          provider: n,
          signature: g
        };
      },
      [p, d, f, y, l]
    )
  };
};
export {
  H as default
};
//# sourceMappingURL=useGetBindWalletInput.js.map
